import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5efd9835")

_pushScopeId("data-v-5efd9835")
const _hoisted_1 = { class: "the-loading" }
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  style: {"margin":"auto","background":"none","display":"block","shape-rendering":"auto"},
  width: "75px",
  height: "75px",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid"
}, [
  /*#__PURE__*/_createVNode("g", { transform: "rotate(0 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.9166666666666666s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(30 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.8333333333333334s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(60 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.75s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(90 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.6666666666666666s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(120 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.5833333333333334s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(150 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.5s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(180 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.4166666666666667s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(210 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.3333333333333333s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(240 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.25s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(270 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.16666666666666666s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(300 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "-0.08333333333333333s",
        repeatCount: "indefinite"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", { transform: "rotate(330 50 50)" }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "47.5",
      y: "21.5",
      rx: "2.5",
      ry: "2.5500000000000003",
      width: "5",
      height: "17",
      fill: "#5d5657"
    }, [
      /*#__PURE__*/_createVNode("animate", {
        attributeName: "opacity",
        values: "1;0",
        keyTimes: "0;1",
        dur: "1s",
        begin: "0s",
        repeatCount: "indefinite"
      })
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})